import { render, staticRenderFns } from "./m-inner-page-header.vue?vue&type=template&id=533b2428&"
import script from "./m-inner-page-header.vue?vue&type=script&setup=true&lang=js&"
export * from "./m-inner-page-header.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports